import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

interface DeleteButtonProps {
  name: string | undefined;
  text?: string;
  containerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  disable?: boolean;
  onDelete: () => void;
  refresh?: () => void;
}

export function DeleteButton({
  name,
  text,
  containerStyle,
  buttonStyle,
  disable,
  onDelete,
  refresh,
}: DeleteButtonProps) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isError, setIsError] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      setIsDeleting(true);
      await onDelete();
      setIsDeleting(false);
      setIsModalOpen(false);
      refresh?.();
    } catch (error) {
      setIsError(true);
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    setIsError(false);
    setIsModalOpen(false);
  };

  return (
    <div
      style={
        containerStyle
          ? containerStyle
          : {
              position: "absolute",
              bottom: 24,
              left: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }
      }
    >
      <Button
        type="primary"
        danger
        disabled={disable}
        onClick={showModal}
        style={buttonStyle ? buttonStyle : { width: "50%", height: "40px" }}
      >
        <DeleteOutlined /> {text ? text : t("delete")}
      </Button>
      <Modal
        title={t("delete")}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={isDeleting}
      >
        {isError ? (
          <p style={{ color: "#EC5B56" }}>
            <strong>{t("error-delete")}</strong>
          </p>
        ) : (
          <p>
            <Trans
              i18nKey="confirm-delete"
              values={{ name }}
              components={{ bold: <strong /> }}
            />
          </p>
        )}
      </Modal>
    </div>
  );
}
